//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {selectPayRecordById,updatePayStatus,approvePayRecord} from "@/api/contract/payRecord";
import {BASIC,JPT_URL} from "@/config/constant"
import promise from '@/axios/promise';
import {Toast } from 'mint-ui';
export default {
    name: "payHumanDayDetail",
  data() {
    return {
      payRecord:{},
      trunDialog:false,
      passDialog:false,
      trunMessage:'',
      passMessage:'',
      panel: '',
      businessKey:this.$route.query.id,
      approve:false,
      taskParam:{},
      picList:[],
      fileList:[],
      //文档服务器地址
      file_url:'',
      appParams:{},
    }
  },
  created(){
    //获取文档服务器路径
      promise({
        url:BASIC + '/dic/item/list/cateCode',
        method:"get",
        async:false,
        params: {cateCode: 'fileUrl'}
      }).then(response=>{
        this.file_url = response[0].dicCode;
      });

    if(this.$route.query.taskParam!=undefined) {
      this.taskParam=this.$route.query.taskParam;
      if(this.taskParam.taskType=='undo'){
        this.approve=true;
        this.appParams.taskDefinitionKey=this.$route.query.taskParam.taskDefinitionKey;
        this.appParams.taskId=this.$route.query.taskParam.taskId;
      }
    }
    var data = {'id':this.$route.query.id};
    selectPayRecordById(data).then(response => {
      this.payRecord=response;
      if(response.comAttachments != null) {
        for(let i = 0; i < response.comAttachments.length; i++) {
          var file = {};
          file.fileId = response.comAttachments[i].fileId;
          file.name = response.comAttachments[i].attName;
          file.fileUrl = response.comAttachments[i].attPath;
          file.contentCode = response.comAttachments[i].contentCode;
          if(response.comAttachments[i].attType == 'pic') {
            this.picList.push(file)
          } else if(response.comAttachments[i].attType == 'doc') {
            this.fileList.push(file);
          }
        }
      }
      this.$previewRefresh();
    });
  },
  methods:{
    /******文件预览start***************/
    preview(fileId){
      var url=JPT_URL+BASIC+"/doc/preview?docId="+fileId;
      this.JX_download(url);
    },

    // 下载最新版本
    JX_download(url){
      plus.nativeUI.showWaiting( "下载中..." );
      //创建下载管理对象
      var SX_down= plus.downloader.createDownload(url,{}, function ( d, status ) {
        // 下载完成
        if ( status == 200 ) {
          plus.nativeUI.closeWaiting();
          //下载成功后的回调函数
          // plus.nativeUI.toast( "下载成功，准备安装" + d.filename );
          plus.runtime.openFile( d.filename, {}, function ( e ) {//调用第三方应用打开文件
            plus.nativeUI.toast('打开失败');
          });

        } else{
          plus.nativeUI.closeWaiting();
          plus.nativeUI.toast('下载失败');
        }
      });
      SX_down.start();
    },
    /******文件预览end***************/
    returnList() {
      if(this.$route.query.taskParam!=undefined){
        this.$router.go(-2);
      }else{
        this.$router.push({path:'/app/project/payRecord/payRecordList'})
      }
    },
    trunDownClk(){
      this.trunDialog=true;
    },
    passClk(){
      this.passDialog=true;
    },
    cancelButton(){
      this.trunDialog=false;
      this.passDialog=false;
      this.trunMessage='';
      this.passMessage='';
    },
    //驳回提交
    turnDownSubmit(){
      // var params={
      //   taskId: this.taskParam.taskId,
      //   status:'E',
      //   msg:this.trunMessage,
      //   vars:{variables:{'status':'E'}},
      // };
      // this.completeTaskByTaskId(params);
      this.appParams.id=this.payRecord.id;
      this.appParams.status='E';
      this.appParams.msg=this.trunMessage;
      this.approvePayRecord();
    },
    //通过提交
    passSubmit(){
      // var params={
      //   taskId: this.taskParam.taskId,
      //   status:'S',
      //   msg:this.passMessage,
      //   vars:{variables:{'status':'S'}},
      // };
      // this.completeTaskByTaskId(params);
      this.appParams.id=this.payRecord.id;
      this.appParams.status='S';
      this.appParams.msg=this.passMessage;
      this.approvePayRecord();
    },
    approvePayRecord(){
      var data={appParams:JSON.stringify(this.appParams)}
      approvePayRecord(data).then(response=>{
        if(response){
          Toast({
            message: '操作成功！',
            position: 'top',
            duration: 1500,
            className:"success"
          });
          this.$router.push({path:"/"});
        }else{
          Toast({
            message: '操作失败！',
            position: 'top',
            duration: 1500,
            className:"error"
          });
        }
      });
    },
    // //流程审批
    // completeTaskByTaskId(params){
    //   promise({
    //     url:BASIC+"/task/completeTaskByTaskId?taskId="+params.taskId+"&status="+params.status+"&msg="+params.msg,
    //     method:"post",
    //     headers:{"Content-Type": "application/json" },
    //     data:JSON.stringify(params.vars),
    //   }).then(response=>{
    //     if(response.code==500){
    //       Toast({
    //         message: '请求错误！',
    //         position: 'top',
    //         duration: 1500,
    //         className:"error"
    //       });
    //     } if(response.code==0){
    //       if(params.status=='S'){
    //         //如果审批通过后是最后一个节点审批 修改合同状态为已完成
    //         if(this.taskParam.taskDefinitionKey=="finance2Approve"){
    //           this.updatePayRecordStatus(this.payRecord.id,'已完成')
    //         }else{
    //           Toast({
    //             message: '操作成功！',
    //             position: 'top',
    //             duration: 1500,
    //             className:"success"
    //           });
    //           this.$router.push({path:"/"});
    //         }
    //       }else if(params.status=='E'){
    //         this.updatePayRecordStatus(this.payRecord.id,'被驳回')
    //       }
    //     }
    //   });
    // },
    // //修改状态
    // updatePayRecordStatus(id,status){
    //   var data={id:id,status:status}
    //   updatePayStatus(data).then(response => {
    //     if(response){
    //       Toast({
    //         message: '操作成功！',
    //         position: 'top',
    //         duration: 1500,
    //         className:"success"
    //       });
    //       this.$router.push({path:"/"});
    //     }
    //   });
    // },
  }
}



// WEBPACK FOOTER //
// ./src/view/payRecord/detail/payHumanDayDetail.vue